import {ObvioEvent} from 'Event'
import {ObieAttendeeLink} from 'lib/event-api/integrations/obie/attendee-links/list'
import {Client} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useMutation, useQueryClient} from 'react-query'

export function useDeleteObieAttendeeLink(params: {
  client: Client
  event: ObvioEvent
}) {
  const {client, event} = params
  const qc = useQueryClient()

  return useMutation<void, {message: string}, ObieAttendeeLink>({
    mutationFn: (link) =>
      client.delete<void>(
        api(`/events/${event.id}/integrations/obie/attendee_links/${link.id}`),
      ),
    onSuccess: (_data, removed) => {
      qc.setQueryData<ObieAttendeeLink[]>(
        ['events', event.id, 'integrations', 'obie', 'attendee_links'],
        (links) => {
          if (!links) {
            return []
          }

          return links.filter((link) => link.id !== removed.id)
        },
      )
    },
  })
}
